import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APP,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, MFA_OAUTH_URL } from '../../../../constants';
import {
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithContinueService {
  loginAuthRememberMeContinueHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitContinue+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithContinue = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const getLoginAuthWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginAuthWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginAuthWithCredentialsUrl
      }
    ];

    const payload: PostWithCredentials = {
      continue: true
    };

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginAuthWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthRememberMeContinueHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_CONTINUE_SERVICE')
      .withCredentials(true)
      .create();
  };
}
